module.exports = __webpack_public_path__ + "static/media/galdisa_blogImg32.08c2cbae.jpg";